import { z } from 'zod';
import { validatedGet, validatedPost, validatedPut, validatedDelete } from '../api-client.ts';
import { ElementoListaSchema } from '@/types/entities/lista-gestita.ts';
import type { NomeLista, ElementoListaInsert } from '@/types/entities/lista-gestita.ts';
import { OkResult } from './shared.ts';

const ListaResult = z.object({ elementi: z.array(ElementoListaSchema) });

type DatiElemento = Partial<ElementoListaInsert>;

export const listeApi = {
  lista: (nome: NomeLista) =>
    validatedGet(`liste/${nome}`, ListaResult),

  crea: (nome: NomeLista, dati: DatiElemento) =>
    validatedPost(`liste/${nome}`, dati, ElementoListaSchema),

  aggiorna: (nome: NomeLista, id: number, dati: DatiElemento) =>
    validatedPut(`liste/${nome}/${id}`, dati, ElementoListaSchema),

  elimina: (nome: NomeLista, id: number) =>
    validatedDelete(`liste/${nome}/${id}`, OkResult),
};
